import axios from "axios";
import { API_BASE_URL } from "../environment";

export const addProductName = async (data) => {
  const res = await axios.post(
    `${API_BASE_URL}/common?table=product_name_list`,
    data
  );
  return res.data;
};

export const getAllProductName = async (data) => {
  const res = await axios.get(
    `${API_BASE_URL}/product-name-list/get-all-product-name?user_type=${data.user_type}&user_id=${data.user_id}&start_date=${data.start_date}&end_date=${data.end_date}`
  );
  return res.data;
};

export const getAllProductByType = async (data) => {
  const res = await axios.get(
    `${API_BASE_URL}/product-name-list/product-name-by-type?user_type=${data.user_type}&user_id=${data.user_id}&product_type=${data.product_type}&active_only=${data.active_only || "false"}`
  );
  return res.data;
};

export const getProductNameById = async (id) => {
  const res = await axios.get(
    `${API_BASE_URL}/common?table=product_list&id=${id}`
  );
  return res.data;
};
export const deleteProductNameById = async (id) => {
  const res = await axios.delete(
    `${API_BASE_URL}/common?table=product_list&id=${id}`
  );
  return res.data;
};
